<template>
  <div v-show="isVisible">
    <v-autocomplete
      ref="autocomplete"
      :label="schema.label || schema.title"
      :class="fieldClasses"
      v-model="localValue"
      :items="options"
      item-text="label"
      item-value="value"
      :autofocus="schema.autofocus"
      :rules="rules"
      :disabled="isDisabled"
      :attach="true"
      @focus="expandMenu"
    />
  </div>
</template>

<script>
import GenericField from '../GenericField';

const AGE_OPTIONS = {
  ca: [
    { label: '17 or older', value: '17+' },
    { label: '16 or younger', value: '16-' },
  ],
  us: [
    { label: '18 or older', value: '18+' },
    { label: '17 & HS grad', value: '17HSG' },
    { label: 'None of the Above', value: 'NA' },
  ],
  wa: [
    { label: '18 or older', value: '18+' },
    { label: '17 or younger', value: '17-' },
  ],
  ak: [
    { label: '18 or older', value: '18+' },
    { label: '17 or younger', value: '17-' },
  ],
};

const CA_ZIP = /^(?:[ABCEGHJ-NPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d)$/i;

const LEGACY_VALUE_MAP = {
  '18 or older': '18+',
  '17 & HS grad': '17HSG',
  'unqualified age': 'NA',
};

export default {
  name: 'AgeBracketField',
  mixins: [GenericField],
  computed: {
    localValue: {
      get() {
        return LEGACY_VALUE_MAP[this.value] ?? this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    countryCode() {
      const { office_number, zip_code } = this.schema;

      if (office_number && /^1/.test(office_number)) return 'ca';

      const zip = '' + (zip_code || '');
      if (CA_ZIP.test(zip)) return 'ca';

      const zipNum = +zip;
      if (zipNum >= 98000 && zipNum <= 99499) return 'wa';
      if (zipNum >= 99500 && zipNum <= 99999) return 'ak';

      return 'us';
    },
    options() {
      return [{ label: '', value: '' }, ...AGE_OPTIONS[this.countryCode]];
    },
  },
  methods: {
    expandMenu() {
      this.$refs.autocomplete?.activateMenu?.();
    },
  },
};
</script>
